import React from 'react';
import {Truck, PackageCheck, Warehouse, RotateCcw, Building2, Star} from 'lucide-react';

const reasons = [
    {
        index: '01',
        title: 'Lebanon-First Focus',
        description: 'We were built for Lebanon\'s unique logistics landscape - understanding the geography, infrastructure, and customer expectations that matter here.',
    },
    {
        index: '02',
        title: 'District Reach',
        description: 'We deliver across most Lebanese districts, from Beirut suburbs to the Bekaa Valley and the far North.',
    },
    {
        index: '03',
        title: 'One Partner, All Services',
        description: 'Storage, packing, delivery, and returns - all under one roof. No need to juggle multiple vendors and coordinate between them.',
    },
    {
        index: '04',
        title: 'Built for Entrepreneurs',
        description: 'We understand the hustle. Flexible terms, transparent pricing, and a team that treats your business like our own.',
    },
];

export default function WhyUs() {
    return (
        <section id="why-us" className="bg-white lg-custom:py-20 py-12">
            <div className="dh-container">
                <div style={{textAlign: 'left', marginBottom: '2.5rem'}}>
                    <div className="uppercase" style={{
                        display: 'inline-block', background: '#e8effc', color: '#0a4abe',
                        borderRadius: '100px', padding: '3px 14px', fontSize: '12px',
                        fontFamily: "'Inter'", fontWeight: 500, marginBottom: '13px', letterSpacing: '0.5px',
                    }}>
                        why delivery hub
                    </div>
                    <h2 style={{
                        fontFamily: "'Bebas Neue'",
                        fontWeight: 900,
                        fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                        lineHeight: '0.95',
                        marginBottom: '1.5rem',
                    }}>
                        the edge<br/>we give you
                    </h2>
                    <div className="text-neutral-500 text-base" style={{
                        fontFamily: "'Inter'",
                        lineHeight: 1.65,
                        textAlign: 'justify',
                        maxWidth: '32rem',
                    }}>

                    </div>
                </div>

                <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                        {reasons.map(r => (
                            <div key={r.index} style={{
                                padding: '1.5rem 0', borderTop: '1px solid rgba(0,0,0,0.08)',
                            }}
                                 onMouseEnter={e => e.currentTarget.querySelector('.r-index').style.color = '#0a4abe'}
                                 onMouseLeave={e => e.currentTarget.querySelector('.r-index').style.color = 'inherit'}
                            >
                                <div className="r-index" style={{
                                    fontFamily: "'Bebas Neue'",
                                    fontSize: '4rem',
                                    lineHeight: '1',
                                    minWidth: '60px',
                                    transition: 'color 0.2s',
                                    marginBottom: '0.5rem',
                                }}>
                                    {r.index}
                                </div>

                                <div style={{
                                    fontFamily: "'Inter'",
                                    fontSize: '1rem',
                                    fontWeight: 700,
                                    color: '#151515',
                                    marginBottom: '8px',
                                }}>{r.title}</div>

                                <div style={{ fontFamily: "'Inter'", fontSize: '0.88rem', color: '#151515', lineHeight: '1.65' }}>{r.description}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}